import { useContext } from 'react';
import { useGetCompany } from '../../../../api/company';
import { Field, Panel } from '../../../../layouts';
import { AR, BusinessFlow, ProductLine, ROType, ScriptFileType } from '../../../../types/enums';
import { formatDateWithTimeframe, formatShortDate, TimeframeType } from '../../../../utils/date-utils';
import { RefetchScope, RetailOrderContext } from '../context/RetailOrderContext';
import CabinetDate from './CabinetDate';
import CallScriptComp from '../../call-script/component/CallScriptComp';

export default function RetailOrderCountertopDates(props: {
	showScheduledInstallDates?: boolean,
	showActualInstallDates?: boolean,
	showInvoiceDate?: boolean,
	editCabinetDates?: boolean,
	showChangeOrderCallScript?: boolean
}) {

	const { order, refetchOrder } = useContext(RetailOrderContext);
	const dealer = useGetCompany(order.details.dealerCompanyID);

	const isMeasureOrder = order.details.roTypeID === ROType.Measure;

	return (
		<>
			{
				order.details.isDeliveryOnly ?
					<>
						<Field label={'Scheduled Delivery Date'} >
							{formatDateWithTimeframe(order.details.scheduledDeliveryDate, TimeframeType.Long)}
						</Field>
						<Field label={'Actual Delivery Date'} >
							{formatShortDate(order.details.deliveryDate)}
						</Field>
					</>
					:
					<>
						<Field label={'Customer Contact Date'}
							visible={order.details.roTypeID !== ROType.CabinetInstallOrder}>
							{formatShortDate(order.details.customerContactDate)}
						</Field>
						<Field label={isMeasureOrder ? 'Ready to Measure Date' : 'Ready to Measure/Template Date'}
							visible={order.details.roTypeID !== ROType.CabinetInstallOrder}>
							{formatShortDate(order.details.readyToMeasureOrTemplateDate)}
						</Field>
						<Field label={isMeasureOrder ? 'Scheduled Measure Date' : 'Measure Date'}
							visible={order.details.roTypeID !== ROType.CabinetInstallOrder}>
							{formatDateWithTimeframe(order.details.measureDate, TimeframeType.Short)}
						</Field>
						{
							isMeasureOrder &&
							<Field label={'Actual Measure Date'}
								visible={(dealer.data?.businessFlowID === BusinessFlow.Lowes) ||
									order.details.roTypeID === ROType.CabinetMeasureOrder} >
								{formatShortDate(order.details.actualMeasureDate)}
							</Field>
						}
						{
							!isMeasureOrder &&
							<>
								<Field label={'Template Date'} >
									{formatDateWithTimeframe(order.details.enterTemplateDate, TimeframeType.Short)}
								</Field>
								<Field label={'Scheduled Install Date'} visible={!!props.showScheduledInstallDates}>
									{formatDateWithTimeframe(order.details.scheduledInstallDate, TimeframeType.Long)}
								</Field>
								<Field label={'Actual Install Date'} visible={!!props.showActualInstallDates}>
									{formatShortDate(order.details.actualInstallDate)}
								</Field>
							</>
						}
					</>
			}
			{
				props.editCabinetDates ?
					<CabinetDate />
					:
					<>
						<Field label={'Cabinet Install Date'} >
							{formatShortDate(order.details.cabinetDate)}
						</Field>

					</>
			}
			{
				props.showChangeOrderCallScript &&
				dealer.data?.businessFlowID === BusinessFlow.Lowes &&
				order.details.productLineID !== ProductLine.LaminateDelivered &&
				(order.details.activeARs.includes(AR.CfiToConfirmOrChangeOrder) || order.details.resolvedARs.includes(AR.CfiToConfirmOrChangeOrder)) &&
				order.details.productLineID !== ProductLine.SmallProjects &&
				(
					<CallScriptComp
						retailOrderID={order.details.retailOrderID}
						retailOrderNumber={order.details.roNumber}
						fileType={ScriptFileType.ChangeOrder}
						fileName={"Change Order"}
						fileAttachment={order.details.files}
						submitCallback={() => refetchOrder(RefetchScope.Files)}
					/>
				)}
			<Field label={'Invoice Date'} visible={props.showInvoiceDate} >
				{formatShortDate(order.details.invoiceDate)}
			</Field>
		</>
	);
}
